import { useEffect, useState } from 'react';
import { doc, onSnapshot } from 'firebase/firestore';
import { getFirebaseAuth, getFirebaseDb } from '../config/firebase';

export type UserProfile = {
  displayName: string | null;
  photoURL: string | null;
};

/** Live profile fields from users/{uid} (name + avatar for the portal chrome). */
export function useUserProfile(enabled: boolean): { profile: UserProfile; ready: boolean } {
  const [profile, setProfile] = useState<UserProfile>({ displayName: null, photoURL: null });
  const [ready, setReady] = useState(false);

  useEffect(() => {
    if (!enabled) return;
    const uid = getFirebaseAuth().currentUser?.uid;
    if (!uid) return;
    const unsub = onSnapshot(doc(getFirebaseDb(), 'users', uid), (snap) => {
      const d = snap.data() || {};
      setProfile({
        displayName: typeof d.displayName === 'string' && d.displayName ? d.displayName : null,
        photoURL: typeof d.photoURL === 'string' && d.photoURL ? d.photoURL : null,
      });
      setReady(true);
    });
    return unsub;
  }, [enabled]);

  return { profile, ready };
}
